import moment from 'moment'

// 开展区域的id回显为文字
function kaizhanquyuHuixian(quyuIdArr, quTreeData, pageType, userInfo, that) {
  if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
    if (pageType === 'launch' && userInfo.municipal_tree_level !== '0' && userInfo.municipal_tree_level.length < 5) {
      // that.kaizhanquyuOnChange([userInfo.municipal_tree_id])
      return userInfo.municipal_tree_id
    } else {
      return null
    }
  } else {
    if (quyuIdArr) {
      var cacheArr = []
      quTreeData[0].children.forEach((item, index) => {
        if (quyuIdArr.includes(item.value)) {
          cacheArr.push(item.title)
        }
      })
      return cacheArr.join('、')
    }
  }
}
function checkKaizhanquyuDisabled(pageType, userInfo) {
  if (pageType === 'launch' && userInfo.municipal_tree_level !== '0' && userInfo.municipal_tree_level.length < 5) {
    return true
  } else {
    return false
  }
}
export const forms = {
  getBaseForm(formData, extend, pageType, quTreeData, processConfigType, that, userInfo) {
    var moren = ''
    if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
      moren = ''
    } else {
      moren = '--'
    }

    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('process_base_title', 'input'),
        label: '项目名称',
        col: '24',
        // disabled: extend.checkDisabled,
        id: 'process_base_title',
        rules: [
          {
            required: true,
            message: '项目名称不能为空'
          }
        ],
        defaultValue:
          formData.process_base_title === '项目帮扶资金类' ? '' : formData.process_base_title,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('time', 'rangePicker'),
        label: '执行日期',
        // disabled: extend.checkDisabled,
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        rules: [
          {
            required: true,
            message: '执行日期不能为空'
          }
        ],
        defaultValue: extend.checkDisabled('date')
          ? formData.start_time
            ? `${formData.start_time} 至 ${formData.end_time}`
            : ''
          : formData.start_time
            ? [
              moment(formData.start_time, 'YYYY-MM-DD') || null,
              moment(formData.end_time, 'YYYY-MM-DD') || null
            ]
            : [null, null],
        col: '8',
        id: 'date',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('project_sponsor', 'input'), // getType('project_sponsor', 'input')
        label: '项目发起方',
        col: '8',
        id: 'project_sponsor',
        defaultValue: extend.checkDisabled('project_sponsor') ? formData.project_sponsor : that.getXiangmufaqifang(), // formData.project_sponsor
        layout: {
          labelCol: '120px'
        },
        disabled: pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch'
      },
      {
        type: getType('help_type', 'select'),
        label: '帮扶类别',
        col: '8',
        id: 'help_type',
        defaultValue: formData.help_type,
        rules: [
          {
            required: true,
            message: '帮扶类别不能为空'
          }
        ],
        options: [
          {
            label: '节日',
            value: '节日'
          },
          {
            label: '助学',
            value: '助学'
          },
          {
            label: '助困',
            value: '助困'
          },
          {
            label: '元旦春节帮困',
            value: '元旦春节帮困'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('project_category', 'input'),
        label: '项目类型',
        col: '8',
        rules: [
          {
            required: true,
            message: '项目类型不能为空'
          }
        ],
        id: 'project_category',
        display: false,
        defaultValue: processConfigType === 'projectFund' ? '资金类' : '服务类', // formData.project_category
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('project_development_area', 'treeSelect'),
        label: '开展区域',
        col: '8',
        rules: [
          {
            required: true,
            message: '开展区域不能为空'
          }
        ],
        treeData: quTreeData,
        onChange: that.kaizhanquyuOnChange,
        id: 'project_development_area',
        defaultValue: kaizhanquyuHuixian(formData.project_development_area, quTreeData, pageType, userInfo, that),
        disabled: checkKaizhanquyuDisabled(pageType, userInfo),
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('service_content', 'input'),
        label: '服务内容',
        col: '8',
        rules: [
          {
            required: processConfigType === 'projectActivity',
            message: '服务内容不能为空'
          }
        ],
        id: 'service_content',
        defaultValue: formData.service_content || '',
        layout: {
          labelCol: '120px'
        },
        display: processConfigType === 'projectActivity' // 服务类帮扶 才有服务内容输入框
      },

      // {
      //   type: getType('project_funding', 'input'),
      //   label: '项目资金',
      //   col: '7',
      //   step: 0.1,
      //   onChange: extend.checkFund,
      //   id: 'project_funding',
      //   defaultValue: formData.project_funding,
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: 'children',
      //   name: 'unit',
      //   col: '1'
      // },
      {
        type: getType('project_responsible_person', 'textarea'),
        label: '项目说明',
        col: '24',
        autoSize: { minRows: 3, maxRows: 3 },
        id: 'project_explain',
        defaultValue: formData.project_explain || moren,
        layout: {
          labelCol: '120px'
        }
      }
    ]
    return data
  }
}
